import {
  Component,
  inject,
  signal
} from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from './core/services/auth.service';
import { SubscriptionAccessService } from './core/services/subscription-access-service';
import { PwaUpdateNotification } from './shared/components/pwa-update-notification/pwa-update-notification';
import { Loader } from './shared/components/loader/loader';
import { UploadWidget } from './features/insights-cube/components/upload-folder/widget/upload-widget/upload-widget';

@Component({
  selector: 'isc-root',
  imports: [
    RouterOutlet, PwaUpdateNotification, Loader, UploadWidget
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {

  // ✅ DI
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);
  readonly subscriptionAccess = inject(SubscriptionAccessService);

  // ✅ signals
  private readonly currentUrl = signal('');

  readonly isLoggedIn = this.auth.isLoggedIn; // assuming signal from your auth service

  // readonly isParticipantView = computed(() =>
  //   this.currentUrl().includes(Route.TESTER)
  // );

  // readonly integrate = computed(() =>
  //   this.currentUrl().includes(Route.INTEGRATION)
  // );

  // optional
  readonly fontSizeMapping = {
    small: '14px',
    medium: '16px',
    large: '18px'
  };

  constructor() {
    this.listenRoute();
    this.applyFontSize();
  }

  // ✅ track route reactively
  private listenRoute() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentUrl.set(event.urlAfterRedirects);
      });
  }

  // ✅ apply font size once
  private applyFontSize() {
    const selectedFontSize = localStorage.getItem('fontSize');

    if (selectedFontSize) {
      document.documentElement.style.fontSize = selectedFontSize;
    }
  }
}